import React, { useState } from 'react'
// import CssBaseline from '@material-ui/core/CssBaseline'
import AnalysisTable from '../components/CashCrewAnalysisForms/AnalysisTable'
import Footer from '../components/Footer';
import NavbarHeader from '../components/NavbarHeader';
import AnalysisCharts from '../components/PredictionAnalysisForms';
import { Account } from '../components/Accounts'

function CashCrewReflection() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Account>
            <NavbarHeader toggle={toggle} />
            <AnalysisTable />
            {/* <AnalysisCharts /> */}
            <Footer />
        </Account>
    );
}

export default CashCrewReflection;